import * as types from '../../types'
import {
    API_URL,
    tiposervicioEntity,
    tiposProductoEntity
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
    validateModel
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';
import {
    toast
} from 'react-toastify';

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.TIPOSERVICIOS_REINICIAR_ESTADO
        })
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'TipoServicio'
        const include = ['tipos_producto.users']
        const take = 100
        const filter = getState().tiposervicios.getIn(['filter'])
        const fields = ['nombre']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
                skip,
                take,
                total: true
            })
            .then((res) => {
                const list = res.data.data.map(x => {
                    x._enabled = true
                    return x
                })
                const records = res.data.total
                dispatch(tableActions.mswTable_mostrarDatos('tiposervicios', 'tiposervicios', list, page, records))
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalCreate(show, id = null) {
    return (dispatch, getState) => {
        const item = id ? getState().tiposervicios.getIn(`tiposervicios.data.${id}`.split('.')).toJS() : tiposervicioEntity()
        dispatch({
            type: types.TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE,
            payload: {
                show,
                item
            }
        })
    }
}

export function guardarTipoServicio() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('tiposervicios', true))
        let data = getState().tiposervicios.getIn(['modalCreate', 'data'])
        const v = String(data.get('activo')) === "true"
        data = data.set('activo', v ? true : false)
        data = data.set('tipos_producto', data.getIn(`tables.tipos_producto.data`.split('.')).valueSeq().toList())
        data.get('tipos_producto').map((x, n) => {
            data = data.setIn(`tipos_producto.${n}.users`.split('.'), data.getIn(`tipos_producto.${n}.users`.split('.')).map(x => x.get('id')))
        })
        const id = data.get('id3n71f13r')

        axios.post(`${API_URL}/tiposervicios`, data)
            .then(res => {
                const tiposervicio = res.data
                tiposervicio._enabled = true
                tiposervicio.id3n71f13r = id
                dispatch({
                    type: types.TIPOSERVICIOS_ACTUALIZAR_REGISTROS,
                    payload: {
                        item: tiposervicio,
                        id
                    }
                })
                dispatch(getDataFromServer(1))
                dispatch(showHideModalCreate(false))
                dispatch(setSavingState('tiposervicios', false))
                displayMessages(dispatch, {
                    success: 'Los registros han sido guardados exitosamente'
                })
            })
            .catch(err => {
                console.log(err)
                dispatch(setSavingState('parametros', false))
                displayMessages(dispatch, err)
            })

    }
}

export function showHideModalCreateTipoProducto(show, id = null) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        if (!show) {
            dispatch({
                type: types.TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE_TIPOPRODUCTO,
                payload: {
                    show
                }
            })
            return
        }

        const modelo = 'User'
        const include = []
        const filter = getState().tiposervicios.getIn(['filter'])
        const fields = ['username', 'name', 'area']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
                total: true
            })
            .then((res) => {
                const tipos_producto = getState().tiposervicios.getIn(`modalCreate.data.tables.tipos_producto.data`.split('.'))
                const item = id ? tipos_producto.getIn(`${id}`.split('.')).toJS() : tiposProductoEntity()
                const users = item.users.map(x => x.username)
                const list = res.data.data.map(x => {
                    x._enabled = true
                    x.selected = users.includes(x.username)
                    return x
                })
                const records = res.data.total
                dispatch({
                    type: types.TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE_TIPOPRODUCTO,
                    payload: {
                        show,
                        item
                    }
                })
                dispatch(tableActions.mswTable_mostrarDatos('tiposervicios', 'modalCreateTipoProducto.data.tables.users', list, 1, records))
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function guardarTipoProducto() {
    return (dispatch, getState) => {
        let data = getState().tiposervicios.getIn(`modalCreateTipoProducto.data`.split('.'))
        let users = data.getIn(`tables.users.data`.split('.')).valueSeq().filter(x => x.get('selected')).map(x => {
            x = x.set('selected', false)
            return x
        }).toJS()
        data = data.deleteIn(`tables.users`.split('.'))
        data = data.setIn(`users`.split('.'), users)
        data = {
            _enabled: true,
            ...data.toJS()
        }
        const modelState = validateModel(data, [{
                key: 'nombre',
                conditions: 'required'
            },
            {
                key: 'descripcion',
                conditions: 'required'
            },
            {
                key: 'valor_maximo',
                conditions: 'required|number|min:0'
            },
            {
                key: 'valor_fijo',
                conditions: 'required'
            },
        ])
        if (modelState.length > 0) {
            modelState.forEach(x => {
                toast.warn(x.message)
            })
            return
        }

        if (data.id3n71f13r) {
            dispatch({
                type: types.TIPOSERVICIOS_ACTUALIZAR_TIPOSPRODUCTO,
                payload: data
            })
        } else {
            const tabledata = getState().tiposervicios.getIn('modalCreate.data.tables.tipos_producto.data'.split('.')).valueSeq().toJS()
            tabledata.push(data)
            let registros = (tabledata) ? tabledata.length : 0
            dispatch(tableActions.mswTable_mostrarDatos('tiposervicios', 'modalCreate.data.tables.tipos_producto', tabledata, 1, registros))
            // const tabledata = getState().tiposervicios.getIn('modalCreateTipoProducto.data.users.data'.split('.'))
            // let registros = (tabledata) ? tabledata.keySeq().count() : 0
            // dispatch(tableActions.mswTable_mostrarDatos('tiposervicios', 'modalCreate.data.tables.tipos_producto', [data], 1, registros + 1))
        }

        dispatch(showHideModalCreateTipoProducto(false))
    }
}

export function adicionarUsuario(item) {
    return (dispatch) => {
        dispatch(tableActions.mwsTable_agregarRegistros('tiposervicios', 'modalCreateTipoProducto.data.users', item))
    }
}

export function filtrarTableLocally() {
    return (dispatch, getState) => {
        const search = getState().tiposervicios.getIn(`modalCreateTipoProducto.data.tables.users.search`.split('.')).toLocaleLowerCase()
        const data = getState().tiposervicios.getIn(`modalCreateTipoProducto.data.tables.users.data`.split('.')).valueSeq()
        const columns = getState().tiposervicios.getIn(`modalCreateTipoProducto.data.tables.users.columns`.split('.')).filter(x => x.TYPE === 'text')
        const ids = data.map(x => {
            let show = false
            columns.forEach(y => {
                const value = x.get(y.VALUE)
                if (typeof value === 'string') {
                    show = show || value.toLocaleLowerCase().includes(search)
                }
            })
            return show ? x.get('id3n71f13r') : null
        }).filter(x => x)
        console.log(ids)
        dispatch({
            type: types.TIPOSERVICIOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE_TIPOPRODUCTO,
            payload: ids
        })
    }
}